module.exports = __webpack_public_path__ + "media/images/icon__locked-beff6fedc1d2e5810d6c0d621a057050.png";